import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SystemLens } from 'pages/systemLens/SystemLens'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return <SystemLens siteId={siteId} />
}

export const Route = createFileRoute('/system-lens/')({
  component: RouteComponent,
  staticData: {
    title: 'System Lens',
  },
})
